// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  width: 90%; /* Adjust the width as needed */
  margin: auto; /* Center the table horizontally */
}

.table-cell {
  border-left: 1 px solid #002129;
  border-right: 1 px solid #002129;
}

.table-header {
  background-color: #002129;
  color: #fff !important;
  border: 2 px solid #002129;
}

.custom-table-header {
  background-color: #00AA72;
  color: #fff !important;
  border: 2 px solid #002129;
}

.odd-row {
  background-color: #ffffff; /* White background for odd rows */
}

.even-row {
  background-color: #f0f1f1; /* Custom background color for even rows */
}

.bottom-row {
  background-color: #C0C0C0; /* Custom background color for even rows */
}

.submit-button {
  display: flex;
  width: 82px;
  height: 36px;
  padding: 6px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.21) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2);
  cursor: default;
  color: #FFF !important;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 130% */
  letter-spacing: 0.46px;
  text-transform: capitalize;
  margin: 0 auto;
  margin-bottom: 32px !important;
}

.submit-button.active {
  background: #00AAD1 !important;
  color: #fff !important;
  font-size: 14px !important;
  cursor: pointer;
}

.scoreCardTableCells {
  padding: 15px 5px !important;
  text-align: center !important;
}

.pickem-mobile-btn {
  margin-bottom: 0px !important;
}

.pickem-leaderboard-table-cells {
  padding: 15px 5px !important;
  line-height: 1.2rem !important;
}

.pickem-stats-table-cells {
  padding: 15px 5px !important;
  line-height: 1.2rem !important;
}

.pool-picks-table-cells {
  padding: 0px 5px !important;
  line-height: 1.2rem !important;
}

/* Custom checkbox styles */`, "",{"version":3,"sources":["webpack://./src/components/NFLPickEm/NFLPickEmStyles/PickEmLeaderboardStyles.scss"],"names":[],"mappings":"AAAA;EACI,UAAA,EAAA,+BAAA;EACA,YAAA,EAAA,kCAAA;AACJ;;AAEA;EACI,+BAAA;EACA,gCAAA;AACJ;;AAEA;EACI,yBAAA;EACA,sBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,sBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,yBAAA,EAAA,kCAAA;AACJ;;AAEA;EACI,yBAAA,EAAA,0CAAA;AACJ;;AAEA;EACI,yBAAA,EAAA,0CAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,yHAAA;EACA,eAAA;EACA,sBAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,8BAAA;AACJ;;AACE;EACE,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;AAEJ;;AACA;EACE,4BAAA;EACA,6BAAA;AAEF;;AAAA;EACE,6BAAA;AAGF;;AADA;EACE,4BAAA;EACA,8BAAA;AAIF;;AADA;EACE,4BAAA;EACA,8BAAA;AAIF;;AADA;EACE,2BAAA;EACA,8BAAA;AAIF;;AAFE,2BAAA","sourcesContent":[".table-container {\n    width: 90%; /* Adjust the width as needed */\n    margin: auto; /* Center the table horizontally */\n}\n\n.table-cell {\n    border-left: 1 px solid #002129;\n    border-right: 1 px solid #002129;\n}\n\n.table-header {\n    background-color: #002129;\n    color: #fff !important;\n    border: 2 px solid #002129;\n}\n\n.custom-table-header {\n    background-color: #00AA72;\n    color: #fff !important;\n    border: 2 px solid #002129;\n}\n\n.odd-row {\n    background-color: #ffffff; /* White background for odd rows */\n}\n\n.even-row {\n    background-color: #f0f1f1; /* Custom background color for even rows */\n}\n\n.bottom-row {\n    background-color: #C0C0C0; /* Custom background color for even rows */\n}\n\n.submit-button {\n    display: flex;\n    width: 82px;\n    height: 36px;\n    padding: 6px 16px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.21)  !important;\n    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20);\n    cursor: default;\n    color:  #FFF  !important;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: Inter;\n    font-size: 14px !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 26px ; /* 130% */\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    margin: 0 auto;\n    margin-bottom: 32px !important;\n  }\n  .submit-button.active {\n    background: #00AAD1 !important;\n    color:#fff  !important;\n    font-size: 14px !important;\n    cursor: pointer;\n  }\n\n.scoreCardTableCells{\n  padding:15px 5px !important;\n  text-align: center !important;\n}\n.pickem-mobile-btn{\n  margin-bottom: 0px !important;\n}\n.pickem-leaderboard-table-cells{\n  padding:15px 5px !important;\n  line-height: 1.2rem !important;\n}\n\n.pickem-stats-table-cells{\n  padding:15px 5px !important;\n  line-height: 1.2rem !important;\n}\n\n.pool-picks-table-cells{\n  padding: 0px 5px !important;\n  line-height: 1.2rem !important;\n}\n  /* Custom checkbox styles */\n// input[type=\"checkbox\"] {\n//     -webkit-appearance: none;\n//     -moz-appearance: none;\n//     appearance: none;\n//     width: 20px;\n//     height: 20px;\n//     border: 2px solid #000000;\n//     border-radius: 4px;\n//     outline: none;\n//     cursor: pointer;\n//     position: relative; /* Ensure the ::after pseudo-element is positioned relative to the checkbox */\n//   }\n\n//   /* Custom checkbox checkmark */\n//   input[type=\"checkbox\"]::after {\n//     content: \"\";\n//     width: 6px;\n//     height: 12px;\n//     border: solid #00AA72;\n//     border-width: 0 2px 2px 0;\n//     position: absolute;\n//     top: 36%;\n//     left: 50%;\n//     transform: translate(-50%, -50%) rotate(50deg);\n//     display: none;\n//   }\n\n//   /* Show checkmark for checked checkboxes */\n//   input[type=\"checkbox\"]:checked::after {\n//     display: block;\n//   }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
